<template>
    <div class="flex-box nopadding wrap pd-left5 un-select" v-show="menu_opens.length > 0">
        <el-tag class="hand mg-right5 mg-bottom5" closable :type="item.curr == 1?'primary':'info'"
             v-for="(item,index) in menu_opens" :key="index" @click='onChange(index)' @close="onClose(index)">
            <span class="mg-right5">●</span>{{item.fn}}
        </el-tag>
    </div>
</template>

<script>
    export default {
        name: "myMenuOpens",
        props:{
            fixed: {
                default: true,
                type: Boolean,
            }
        },
        computed:{
            menu_opens:function () {
                return this.$store.state.baseData.menu_opens;
            }
        },
        methods: {
            onChange(index){
                this.$base.linkTo(this.menu_opens[index].url);
            },
            onClose(index){
                this.$store.commit("delBaseData_MenuOpens",index);
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myMenuOpens.vue